// src/styles/theme.js
export const theme = {
     effects: {
      
    backdropBlur: 'blur(10px) saturate(180%)',
    softGlow: (color) => `0 0 20px ${color}33`, // Glow effect
  },

  colors: {
   
    glassBg: 'rgba(255, 255, 255, 0.1)', // For frosted glass background
    glassBorder: 'rgba(255, 255, 255, 0.2)',
    primaryGradient: 'linear-gradient(135deg, #6A11CB 0%, #2575FC 100%)', // Example bold gradient
    secondaryGradient: 'linear-gradient(135deg, #2575FC 0%, #6A82FB 100%)',
    accentGradient: 'linear-gradient(135deg, #FF6B6B 0%, #FFC107 100%)', // Example using accent and warning
    shadowLight: 'rgba(106, 27, 203, 0.15)', // Softer shadow from primary color
    primary: '#6A11CB', // A vibrant purple
    primaryLight: '#A450E0', // Lighter shade for gradients or hovers
    primaryDark: '#3C1053',  // Darker shade
    secondary: '#2575FC', // A cool blue as accent
    secondaryLight: '#6A82FB',
    accent: '#FF6B6B', // A warm, energetic accent (e.g., for notifications or important actions)
    
    background: '#F8F9FA',    // Very light grey, almost white
    surface: '#FFFFFF',        // Pure white for cards, navbar
    
    textPrimary: '#212529',    // Dark grey for primary text
    textSecondary: '#495057',  // Medium grey for secondary text
    textMuted: '#6C757D',      // Lighter grey for less important text
    
    border: '#DEE2E6',         // Standard border color
    lightBorder: '#E9ECEF',    // Lighter border for subtle divisions

    success: '#198754',
    danger: '#DC3545',
    warning: '#FFC107',
    info: '#0DCAF0',

    // Sidebar Specific
    sidebarBg: '#1F2937', // Dark, sophisticated grey
    sidebarText: '#D1D5DB', // Light grey text on dark bg
    sidebarTextHover: '#FFFFFF',
    sidebarIcon: '#9CA3AF',
    sidebarIconHover: '#FFFFFF',
    sidebarActiveBg: 'rgba(106, 17, 203, 0.2)', // Translucent primary for active state
    sidebarActiveText: '#E0CFFC', // Lighter purple for active text
    sidebarActiveIndicator: '#A450E0', // Primary light for the active border
  },
  fonts: {
    main: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    heading: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  spacing: {
    xxs: '4px',
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
    xlarge: '16px',
    round: '50%',
  },
  shadows: {
    xs: '0 1px 2px 0 rgba(0, 0, 0, 0.03)',
    sm: '0 1px 3px 0 rgba(0, 0, 0, 0.07), 0 1px 2px -1px rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.08), 0 2px 4px -2px rgba(0, 0, 0, 0.05)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -4px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 8px 10px -6px rgba(0, 0, 0, 0.05)',
    none: 'none',
  },
  breakpoints: {
    xs: '0px',    // Mobile first
    sm: '640px',  // Small tablets
    md: '768px',  // Tablets
    lg: '1024px', // Laptops
    xl: '1280px', // Desktops
  },
  transitions: {
    short: 'all 0.15s ease-in-out',
    medium: 'all 0.25s ease-in-out',
    long: 'all 0.4s ease-in-out',
  },
  navbarHeight: '70px',
  sidebarWidth: '280px',
  sidebarWidthCollapsed: '0px', // Can be ~80px for an icon-only collapsed state
};
